import React from "react";
import Section from "../../../components/layout/marketing/Section";
import { FEATURES } from "../../../config/marketing/features";
import FeatureRow from "../components/FeatureRow";
import Chip from "../../../components/common/chip";

export default function FeaturesSection() {
    return (
        <Section id="features" className="">
            {/* Section Header */}
            <div className="mx-auto max-w-3xl text-center ">
                <Chip className="mb-4">Features</Chip>
                <h2 className="text-4xl font-semibold text-text-primary md:text-5xl">
                    Everything You Need to{" "}
                    <span className="bg-brand-gradient bg-clip-text text-transparent">Go Digital</span> and{" "}
                    <span className="bg-brand-gradient bg-clip-text text-transparent">Stay Organized</span>.
                </h2>
            </div>
            <div className="mt-20 bg-white flex flex-col gap-16 lg:gap-0 lg:rounded-2xl lg:shadow-md rounded-bg-subtle">
                {FEATURES.map((feature, index) => (
                    <FeatureRow key={feature.id} feature={feature} reverse={index % 2 !== 0} />
                ))}
            </div>
        </Section>
    );
}
